import { render, staticRenderFns } from "./pay-end.vue?vue&type=template&id=2bd91534&scoped=true&"
import script from "./pay-end.vue?vue&type=script&lang=js&"
export * from "./pay-end.vue?vue&type=script&lang=js&"
import style0 from "./pay-end.vue?vue&type=style&index=0&id=2bd91534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd91534",
  null
  
)

export default component.exports